// apps/client/src/state/slices/fullscreen.ts (full screen button, 2026-10-18) — whether the short guide to the home-screen app is open
// (ui/fullscreen.tsx): the Full screen button opens it on an iPhone, from the rotate card, the corner before a town or the in-town Menu,
// and App draws it over everything, the rotate card included.
import type { SliceCreator } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- declaration merging into GameStore
declare module '../types' { interface GameStore extends FullscreenSlice {} }

export interface FullscreenSlice {
  fullscreenGuide: boolean;
  openFullscreenGuide(): void;
  closeFullscreenGuide(): void;
}

export const slice: SliceCreator<FullscreenSlice> = (set) => ({
  fullscreenGuide: false,
  openFullscreenGuide: () => set({ fullscreenGuide: true }),
  closeFullscreenGuide: () => set({ fullscreenGuide: false }),
});
